import { Component, EventEmitter, Output } from '@angular/core';
import { Concepto, Impuestos, Impuestos2, ImpuestosLocales, totalesEncabezado } from '../../../../shared/models';
import { FormArray } from '@angular/forms';

interface ImpuestosSumados {
  traslados: number;
  retenciones: number;
}


@Component({
  selector: 'app-form-conceptos',
  standalone: false,
  templateUrl: './form-conceptos.component.html',
  styleUrl: './form-conceptos.component.scss',
})
export class FormConceptosComponent {
  public listConceptos: FormArray = new FormArray([]);
  public impuestosAgrupados: Impuestos = {
    retenciones: [],
    traslados: []
  };

  public impuestosDesagrupados: ImpuestosSumados = {
    retenciones: 0,
    traslados: 0,
  }

  public impuestosLocales: ImpuestosLocales = {
    retencionesLocales: [],
    trasladoLocales: [],
    totalImpuestosRetenidos: null,
    totalImpuestosTrasladados: null
  }

  public subtotalEncabezado: number = 0;
  public totalEncabezado: number = 0;
  readonly ignoredTaxes = ["001", "002", "003"];

  @Output() public send_data_concepto: EventEmitter<Concepto[]> = new EventEmitter<Concepto[]>();
  @Output() public send_data_impuestos: EventEmitter<Impuestos2> = new EventEmitter<Impuestos2>();
  @Output() public send_data_totales_encabezados: EventEmitter<totalesEncabezado> = new EventEmitter<totalesEncabezado>();
  @Output() public send_data_impuestos_locales: EventEmitter<ImpuestosLocales> = new EventEmitter<ImpuestosLocales>();

  public receiveConceptos(event: FormArray, fromDelete: boolean): void {
    const ignoredTaxes = ["001", "002", "003"];
    if (fromDelete === false) {
      this.listConceptos = event;
    }


    // this.impuestosAgrupados = this.agruparImpuestos(this.listConceptos.value);
    this.impuestosDesagrupados = this.sumTaxImports(this.listConceptos.value);


    // ----------------------IMPUESTOS LOCALES ----------------------------------------->

    const agrupadoImpuestosLocales = this.listConceptos.value.reduce(
      (acc, item) => {
        const { traslados, retenciones } = item.impuestos;

        traslados
          .filter(
            (t) => !ignoredTaxes.includes(t.impuesto) // Filtrar impuestos no ignorados
          )
          .forEach((t) => {
            const key = `${t.impuesto}_${t.tipoFactor}_${t.tasaoCuota}`;
            if (!acc.traslados[key]) {
              acc.traslados[key] = { ...t };
            } else {
              acc.traslados[key].base += t.base;
              acc.traslados[key].importe += t.importe;
            }
          });

        retenciones
        .filter(
          (t) => !ignoredTaxes.includes(t.impuesto) // Filtrar impuestos no ignorados
        ).
        forEach((r) => {
          const key = `${r.impuesto}_${r.tipoFactor}_${r.tasaoCuota}`;
          if (!acc.retenciones[key]) {
            acc.retenciones[key] = { ...r };
          } else {
            acc.retenciones[key].base += r.base;
            acc.retenciones[key].importe += r.importe;
          }
        });

        return acc;
      },
      { traslados: {}, retenciones: {} }
    );

    const resultadoImpLocales: any = {
      
      trasladoLocales: Object.values(agrupadoImpuestosLocales.traslados),
      retencionesLocales: Object.values(agrupadoImpuestosLocales.retenciones),
      totalImpuestosTrasladados: Object.values(agrupadoImpuestosLocales.traslados).reduce(
        (sum: any, t: any) => sum + t.importe,
        0
      ),
      totalImpuestosRetenidos: Object.values(agrupadoImpuestosLocales.retenciones).reduce(
        (sum: any, r: any) => sum + r.importe,
        0
      ),
    };

    const ImpLocalesFinales = {
      ...resultadoImpLocales,
      trasladoLocales: resultadoImpLocales.trasladoLocales.map(({ tasaoCuota, ...resto }) => ({
        ...resto,
        tasa: tasaoCuota
      })),
      retencionesLocales: resultadoImpLocales.retencionesLocales.map(({ tasaoCuota, ...resto }) => ({
        ...resto,
        tasa: tasaoCuota
      }))
    };

    this.send_data_impuestos_locales.emit(ImpLocalesFinales);

    // ----------------------IMPUESTOS LOCALES ----------------------------------------->


    // ----------------------IMPUESTOS FEDERALES ----------------------------------------->

    const agrupadoImpuestosFederales = this.listConceptos.value.reduce(
      (acc, item) => {
        const { traslados, retenciones } = item.impuestos;

        traslados
          .filter(
            (t) => ignoredTaxes.includes(t.impuesto) // Filtrar impuestos no ignorados
          )
          .forEach((t) => {
            const key = `${t.impuesto}_${t.tipoFactor}_${t.tasaoCuota}`;
            if (!acc.traslados[key]) {
              acc.traslados[key] = { ...t };
            } else {
              acc.traslados[key].base += t.base;
              acc.traslados[key].importe += t.importe;
            }
          });

        retenciones.forEach((r) => {
          const key = `${r.impuesto}_${r.tipoFactor}_${r.tasaoCuota}`;
          if (!acc.retenciones[key]) {
            acc.retenciones[key] = { ...r };
          } else {
            acc.retenciones[key].base += r.base;
            acc.retenciones[key].importe += r.importe;
          }
        });

        return acc;  
      },
      { traslados: {}, retenciones: {} }
    );

    const resultadoImpFederales: any = {
      traslado: Object.values(agrupadoImpuestosFederales.traslados),
      retenciones: Object.values(agrupadoImpuestosFederales.retenciones),
      totalImpuestosTrasladados: Object.values(agrupadoImpuestosFederales.traslados).reduce(
        (sum: any, t: any) => sum + t.importe,
        0
      ),
      totalImpuestosRetenidos: Object.values(agrupadoImpuestosFederales.retenciones).reduce(
        (sum: any, r: any) => sum + r.importe,
        0
      ),
    };
    
    resultadoImpFederales.totalImpuestosRetenidos=(resultadoImpFederales.totalImpuestosRetenidos).toFixed(2);
    resultadoImpFederales.retenciones.forEach(element => {
      element.importe=(element.importe).toFixed(2);
    });
    this.send_data_impuestos.emit(resultadoImpFederales);

    // ----------------------IMPUESTOS FEDERALES ----------------------------------------->

    this.subtotalEncabezado = this.listConceptos.value.reduce((sum, item) => sum + (item.importe || 0), 0);
    this.totalEncabezado = this.subtotalEncabezado - this.impuestosDesagrupados.retenciones + this.impuestosDesagrupados.traslados;

    this.send_data_totales_encabezados.emit({
      subTotal: this.subtotalEncabezado.toString(),
      total: this.totalEncabezado.toString()
    });

    const filteredData = this.listConceptos.value.map(item => ({
      ...item,
      impuestos: {
        traslados: item.impuestos.traslados.filter(t => ignoredTaxes.includes(t.impuesto)),
        retenciones: item.impuestos.retenciones.filter(r => ignoredTaxes.includes(r.impuesto)),
      },
    }));

  
  filteredData.forEach(element => {
    element.impuestos.retenciones.forEach(element => {
      element.importe=(element.importe).toFixed(2);
    });
  });
    this.send_data_concepto.emit(filteredData);
  }

  public deleteConcepto(indice: number) {
    this.listConceptos.removeAt(indice);
    this.receiveConceptos(this.listConceptos, true);
  }

  // public agruparImpuestos(listaConceptos: Concepto[]): Impuestos {
  //   const result = {
  //     traslados: [],
  //     retenciones: []
  //   };
  //   listaConceptos.forEach(elem => {
  //     if (elem.impuestos) {
  //       ["traslados", "retenciones"].forEach(key => {
  //         if (elem.impuestos[key]) {
  //           elem.impuestos[key].forEach(tax => {
  //             const existingTax = result[key].find(
  //               t => t.impuesto === tax.impuesto && t.tasaoCuota === tax.tasaoCuota
  //             );

  //             if (existingTax) {
  //               existingTax.importe += tax.importe;
  //               existingTax.base += tax.base;
  //             } else {
  //               result[key].push({ ...tax });
  //             }
  //           });
  //         }
  //       });
  //     }
  //   })
  //   return result;
  // }

  public sumTaxImports(data: Concepto[]): ImpuestosSumados {
    let result = { traslados: 0, retenciones: 0 };

    data.forEach(item => {
      if (item.impuestos) {
        ["traslados", "retenciones"].forEach(key => {
          if (item.impuestos[key]) {
            result[key] += item.impuestos[key].reduce((sum, tax) => sum + tax.importe, 0);
          }
        });
      }
    });

    return result;
  }
}

